// src/components/CTA.jsx
import React from "react";

export default function CTA() {
  return (
    <div className="bg-gray-900 text-white py-16 px-6 text-center rounded-2xl shadow-lg">
      <h2 className="text-3xl font-bold mb-4">Try Our Virtual Keyboard Today!</h2>
      <p className="text-gray-300 mb-6">
        Experience seamless typing with hand tracking and AI-powered interaction.
      </p>

      {/* Download Button */}
      <a
        href="https://github.com/NandhiniN0506/VirtualOSKeyboard/releases/download/v1.0/VirtualKeyboardSetup.exe"
        download
        className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-xl transition duration-300"
      >
        Download Virtual Keyboard
      </a>
    </div>
  );
}
